/**
 * Storyella 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * Storyella 品牌特定主题配置
 */
export const theme = {
  // 引用装饰线颜色 (Storyella 使用粉色调,基于主色 #FF4774)
  quoteColor: 'rgba(255, 71, 116, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
